import { useState } from "react";
import DragDropFile from "../core/forms/drag-drop-file";

export default function CaseCreateAttachments({
	title = "Payment Receipts",
	hasAttachments,
	onFilesChange,
	onRemoveFile,
	onClearFile,
	initialFiles,
}: {
	title: string;
	hasAttachments: boolean;
	initialFiles?: any;
	onRemoveFile?: (file: File) => void;
	onFilesChange?: (files: File[]) => void;
	onClearFile?: (files: File[]) => void;
}) {
	const [files, setFiles] = useState<File[]>([]);

	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

	const handleClear = (value: any) => {
		setFiles([]);
		setSelectedFiles([]);
		onClearFile?.(value);
		onFilesChange?.([]);
	};

	const handleChange = (value: any) => {
		setFiles(value);
		setSelectedFiles(value);
		onFilesChange?.(value);
	};

	const handleDelete = (removedFile: any) => {
		// Update local state to remove the file
		const updatedFiles = files.filter((f: any) => {
			// Compare by name and size to identify the file
			return !(f.name === removedFile.name && f.size === removedFile.size);
		});

		setFiles(updatedFiles);
		setSelectedFiles(updatedFiles);

		// Notify parent components
		onRemoveFile?.(removedFile);
		onFilesChange?.(updatedFiles);
	};

	return (
		<div className="flex flex-col w-full rounded-md border border-border/50 overflow-hidden">
			<div className="flex flex-row items-center justify-between w-full p-4 gap-4 bg-slate-50">
				<span className="text-base font-semibold">{title}</span>
				{/* <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <Button>
              <span className="">Add</span>
              <IconChevronDown size={18} stroke={2} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" sideOffset={8}>
            <DropdownMenuGroup>
              <DropdownMenuItem
                onClick={async () => {
                  const newFile = { name: "created-document.docx" };
                  setFiles((prevFiles: any) => [...prevFiles, newFile]);
                  const modalId = modal.openModal({
                    allowClose: true,
                    title: "Create File",
                    description:
                      "Yes, this is for the description, Please make it short",
                    size: "full",
                    showHeader: false,
                    showFooter: false,
                    component: (
                      <CaseCreateEditorModal
                        handleSubmit={async (values: any) => {
                          modal.closeModal(modalId);
                        }}
                      />
                    ),
                  });
                }}
              >
                <div className="flex flex-row items-center w-full py-1 px-2">
                  Create File
                  <DropdownMenuShortcut>
                    <IconFile size={18} stroke={1.5} />
                  </DropdownMenuShortcut>
                </div>
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu> */}
			</div>

			<div className="flex flex-col w-full gap-4 p-4">
				<DragDropFile
					isCaseFiling={true}
					initialFiles={initialFiles}
					onClear={async (files) => {
						handleClear(files);
					}}
					onSubmit={async (files) => {
						handleChange(files);
					}}
					onDelete={(file: any) => {
						handleDelete(file);
					}}
				/>
			</div>
		</div>
	);
}
